import { useSelector } from "react-redux";
import PresortDemo from "../components/table/DataTable";
import { useEffect, useState } from "react";
import { useGetUsersQuery } from "../store/api/userAPI";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import TextEditor from "../components/UI/editor/TextEditor";
import "./page.css";
import { } from "../store/api/orderAPI";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { confirmPopup } from "primereact/confirmpopup";
import { actionsColumn } from "../metadata/actions";
import {
  useCreateOrUpdateActionsMutation,
  useGetActionsQuery,
  useDeleteActionsMutation,
} from "../store/api/actions";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { useTranslation } from "react-i18next";

function Actions() {
  const { data, error, isLoading } = useGetActionsQuery();
  const { t } = useTranslation();
  const [createOrUpdateActions] = useCreateOrUpdateActionsMutation();
  const actionsColumnTr = useTranslatedColumns(actionsColumn);
  const [deleteActions] = useDeleteActionsMutation();
  const delActions = (event, [row]) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Вы точно хотите удалить?",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "reject",
      accept: (e) => {
        deleteActions(row.tarif_guid);
      },
    });
  };
  const actions = useActionsHook([]);
  const items = [
    {
      label: "React Website",
      icon: "pi pi-external-link",
      command: () => {
        // window.location.href = 'https://react.dev/';
      },
    },
  ];

  const [formData, setFormData] = useState({});

  const [visibleLeft, setVisibleLeft] = useState({
    visible: false,
    data: null,
  });

  function toggleSidebar(bool, data) {
    setFormData(data);
    setVisibleLeft((state) => {
      return {
        visible: bool,
        data: data,
      };
    });
  }

  const onBlur = (e, attr, value) => {
    setFormData((state) => {
      return {
        ...state,
        [attr]: value,
      };
    });
  };

  return (
    <>
      {/* <p
        style={{
          paddingLeft: 12,
          fontSize: 18,
          fontWeight: 600,
        }}
      >
        {t("action")}
      </p> */}
      <PresortDemo
        isLoading={isLoading}
        data={data ?? []}
        column={
          actionsColumnTr.filter((i) => !i.hidden) ?? Object.keys(data?.[0])
        }
        toggleSidebar={toggleSidebar}
        deleteHandler={(row, field) => {
          console.log(row, field);
        }}
        actions={actions}
        id="id"
      />
      <SpeedDial
        model={items}
        radius={120}
        type="quarter-circle"
        // onClick={() => {
        // 	toggleSidebar(true, {});
        // }}
        direction="up-left"
        style={{ right: 15, bottom: 15 }}
      />
      <Sidebar
        visible={visibleLeft.visible}
        position="right"
        onHide={() => {
          toggleSidebar(false);
        }}
        style={{ width: "50vw" }}
      >
        {/* <div className="user-sidebar"> */}
        <div className="user-sidebar-edit">
          {actionsColumnTr
            .filter((i) => i.editor)
            .map((el) => {
              return (
                <div>
                  <Editor {...el} onBlur={onBlur} data={formData} />
                </div>
              );
            })}
          <div></div>
          <MyButton
            label={t("save")}
            onClick={() => {
              createOrUpdateActions(formData);
              console.log(formData);
            }}
          />
        </div>
      </Sidebar>
    </>
  );
}

export default Actions;
